import React, { useContext, useState } from 'react'
import { Link, Navigate } from 'react-router-dom'
import NewMenu from '../../components/NewMenu';
import Exit from '../../components/Exit';
import Stats from '../../components/Stats';
import NewProducts from '../../components/NewProducts';
import { AuthContext } from '../../context/auth';
import NewProductsNew from '../../components/NewProducts/new';
import AddressPage from '../../components/NewProducts/addressPage';

const NewProfile = () => {
  const {currentUser} = useContext(AuthContext);
  const [path, setPath] = useState(1);

  if(currentUser){
    return (
      <div className='bg-back bg-cover h-full w-full font-Roboto'>
          <div className='h-screen'>
          <div className='pt-4'></div>
          <div className='bg-white/50 rounded-xl p-4 xs:mx-2 md:mx-20'>
            <div className='flex justify-center'>
              <img className='xs:h-14 md:h-24 rounded-full p-1 bg-white' src='../4.png'/>
            </div>
          </div>
          <div className='bg-white border border-white rounded-xl p-4 xs:mx-2 mt-2 md:mx-20 flex justify-between items-center'>
            <div className='gap-2 flex text-black xs:text-xs md:text-lg'>
              <h1 onClick={()=> setPath(1)} className={path === 1 ? 'font-bold cursor-pointer':' cursor-pointer'}>Захиалга</h1>
              <h1 onClick={()=> setPath(2)} className={path === 2 ? 'font-bold cursor-pointer':' cursor-pointer'}>Хаягийн мэдээлэл</h1>
            </div>
            <div className='flex items-center gap-3'>
              <NewMenu/>
              <Exit/>
            </div>
          </div>

          <div>
            {
              path === 1 ?
              <NewProductsNew/>
              :
              <AddressPage/>
            }
          </div>
          {/* <Stats/> */}
          </div>
      </div>
    )
  }else{
    return <Navigate to='/'/>
  }
}

export default NewProfile
